import { Action } from '../actions';

export default function (unbalancedState = {}, action) {
  switch (action.type) {
    case Action.Payment.Unbalanced.Cache:
      return {
        ...unbalancedState,
        state: action.payload.state,
        txlist: action.payload.txlist,
      };
    default:
      break;
  }
  return unbalancedState;
}
